
import React from 'react';
import { TabContainer, TabButton } from './StyledComponents';
import TooltipWrapper from './TooltipWrapper';

const manualTypeMap: Record<string, string> = {
  "Betreibende": "Betreibende",
  "UntM": "Unterkunftsmanagement",
  "ZuwSt": "Zuweisende Stelle",
};

interface GroupSelectorProps {
  groupKeys: string[];
  currentGroupKey: string | null;
  onSelectGroup: (groupKey: string) => void;
  isNavigationLocked?: boolean;
  tooltipText?: string;
}

const GroupSelector: React.FC<GroupSelectorProps> = ({ 
  groupKeys, 
  currentGroupKey, 
  onSelectGroup, 
  isNavigationLocked = false,
  tooltipText 
}) => {
  if (groupKeys.length <= 1) {
    return null; // Don't show tabs if there's only one group
  }

  return (
    <TabContainer>
      {groupKeys.map(key => (
        <TooltipWrapper 
          key={key}
          tooltipText={key !== currentGroupKey ? tooltipText : undefined}
          showTooltip={isNavigationLocked && key !== currentGroupKey}
        >
          <TabButton
            isActive={key === currentGroupKey}
            isDisabled={isNavigationLocked && key !== currentGroupKey}
            onClick={() => {
              if (!isNavigationLocked || key === currentGroupKey) {
                onSelectGroup(key);
              }
            }}
          >
            {manualTypeMap[key] || key}
          </TabButton>
        </TooltipWrapper>
      ))}
    </TabContainer>
  );
};

export default GroupSelector;
